import React, { useState, useEffect } from "react";
import { faqcontent } from "../../utils/faq";
import TagFaces from "@material-ui/icons/TagFaces";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./Faq.css";

const Faq = ({ city }) => {
  const [visibleItems, setVisibleItems] = useState(6);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [expandedItems, setExpandedItems] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth <= 768) {
        setVisibleItems(3);
      } else {
        setVisibleItems(6);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadMore = () => {
    setVisibleItems((prev) => prev + 6);
  };

  const toggleExpand = (index) => {
    setExpandedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const itemsToShow = isMobile
    ? faqcontent.slice(0, visibleItems)
    : faqcontent.slice(0, visibleItems);
  const leftItems = itemsToShow.slice(0, Math.ceil(itemsToShow.length / 2));
  const rightItems = itemsToShow.slice(Math.ceil(itemsToShow.length / 2));

  return (
    <div className="faqRoot">
      <h2 className="faq-title">Vanliga frågor</h2>
      <p className="infoText">
        Här hittar du svar på de vanligaste frågorna vi får.
      </p>
      <div className="faqContainer">
        <div className="faqColumn">
          {leftItems.map((el, i) => (
            <div
              key={i}
              className={`faqItem ${expandedItems.includes(i) ? "expanded" : "collapsed"}`}
            >
              <div className="question" onClick={() => toggleExpand(i)}>
                <TagFaces className="icon" />
                <span className="questionText">{el.title}</span>
                <ExpandMoreIcon className="expandIcon" />
              </div>
              {expandedItems.includes(i) && (
                <div className="answer">
                  {!city
                    ? el.text.replaceAll("i City", "")
                    : el.text.replaceAll("City", city)}
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="divider"></div>
        <div className="faqColumn">
          {rightItems.map((el, i) => (
            <div
              key={i + leftItems.length}
              className={`faqItem ${expandedItems.includes(i + leftItems.length) ? "expanded" : "collapsed"}`}
            >
              <div
                className="question"
                onClick={() => toggleExpand(i + leftItems.length)}
              >
                <TagFaces className="icon" />
                <span className="questionText">{el.title}</span>
                <ExpandMoreIcon className="expandIcon" />
              </div>
              {expandedItems.includes(i + leftItems.length) && (
                <div className="answer">
                  {!city
                    ? el.text.replaceAll("i City", "")
                    : el.text.replaceAll("City", city)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {visibleItems < faqcontent.length && (
        <div className="faqFooter">
          <div className="fog"></div>
          <button className="loadMoreButton" onClick={loadMore}>
            Ladda mer
          </button>
        </div>
      )}
    </div>
  );
};

export default Faq;
